import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import sessionManager, { eVariableType } from './SessionManager';

const useAuth = () => {
    const tk = sessionManager.get(eVariableType.Token);

    if (tk === null || tk === '') return false;
    else return true;
};

export function PrivateRoute() {
    const isAuthenticated = useAuth();
    return <>{isAuthenticated ? <Outlet /> : <Navigate to="/login" />}</>;
}

const useAuthMagClienti = () => {
    const tk = sessionManager.get(eVariableType.Tokencliente);

    if (tk === null || tk === '') return false;
    else return true;
};

export function PrivateMagClientiRoute() {
    const isMagclientiAuthenticated = useAuthMagClienti();

    return <>{isMagclientiAuthenticated ? <Outlet /> : <Navigate to="/loginclienti" />}</>;
}
